import { Components, ExtendedComponentSchema } from "formiojs";

import editForm from "./mipro-variable-field-form";


export default class MiproVariableField extends Components.components.textfield {

    public static editForm: (...extend: any[]) => any = editForm;

    public static schema(): ExtendedComponentSchema {
        return Components.components.textfield.schema({
            input: true,
            disabled: false,
            label: "Variable Field",
            placeholder: "Enter text",
            key: "miproVariableField",
            type: "miproVariableField",
            variableName: "", // Custom property to store the query parameter name.
        });
    }

    public init(): void {
        super.init();

        // Populate with query parameter value if the input is empty.
        this.setVariableValue();
    }

    private setVariableValue(): void {
        if (!this.component?.variableName) return;

        // Only populate if there's no existing value.
        if (!!this.dataValue) return;

        const value: string = this.getQueryParam(this.component.variableName);

        // Only set the value if it exists and is not null/undefined/empty.
        if (!value?.length) return;

        // Set the value in the input.
        this.setValue(value, {});
    }

    private getQueryParam(key: string): string {
        // Check if given key is valid (it is a populated string).
        if (!key || typeof key !== "string") return undefined;

        // Check if window and location are available (browser environment).
        if (!window?.location) return undefined;

        try {
            // Parse query parameters from the current URL.
            const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
            const value: string = urlParams.get(key);

            if (value === null) return undefined;

            // Decode the value in case it was URL-encoded.
            return decodeURIComponent(value);

        } catch (error) {
            // If any error occurs, return undefined.
            return undefined;
        }
    }

    public static get builderInfo(): any {
        return {
            title: "Variable Field",
            weight: 10,
            icon: "code",
            group: "basic",
            schema: MiproVariableField.schema(),
            documentation: "/userguide/form-building/form-components#text-field",
        };
    }
}

Components.addComponent("miproVariableField", MiproVariableField);
